import firebase from 'firebase'

var firebaseConfig = {
  apiKey: "AIzaSyAkMsMKM0TBVhsOib3igwtq3fHm_hk5Z90",
  authDomain: "todays3line.firebaseapp.com",
  databaseURL: "https://todays3line.firebaseio.com",
  projectId: "todays3line",
  storageBucket: "todays3line.appspot.com",
  messagingSenderId: "478637209049",
  appId: "1:478637209049:web:1c9ea00df79e69b1c595c8"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

export default firebaseApp.firestore()